<template>
  <div class="work_index">
    <h1
      class="title"
      v-text="title"
    />
    <a-spin
      v-if="loadingContent"
      class="spin-style"
    />
    <a-form
      v-if="!loadingContent"
      :form="form"
      class="edit-main"
    >
      <editor
        :my-form="form"
        :height="480"
        :data="editData"
        class="edit_container"
        @change="editChange"
      />
      <a-form-item>
        <a-button
          class="edit_btn"
          type="primary"
          :disabled="addComplete"
          @click="subWorkLog"
        >
          {{ $t('message["21"]') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script type="text/ecmascript-6">
import Editor from '@/pc/inquery/formItem/Editor'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    Editor
  },
  data () {
    return {
      editContent: {},
      form: this.$form.createForm(this)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getWorkLogoInfo()
    })
  },
  computed: {
    ...mapState('record', ['preWorkLogo', 'addComplete', 'loadingContent']),
    ...mapState(['baseinfo']),
    editData () {
      return Object.assign({}, { fieldvalue: this.preWorkLogo.content }, { fieldkey: 'content' }, { isneeded: 0 })
    },
    title () {
      const { title } = this.$route.meta
      return title
    }
  },
  watch: {
    baseinfo (newVal) {
      document.title = this.title + ' - ' + newVal.projectname + '-' + newVal.comname
    }
  },
  methods: {
    ...mapActions('record', ['addWorkLog', 'getWorkLogoInfo']),
    editChange (info) {
      this.editContent = Object.assign({}, { content: info })
    },
    subWorkLog () {
      this.$bus.$emit('myQuillEditorBlur')
      this.form.validateFields(
        (err) => {
          if (!err) {
            this.addLog(this.editContent)
          }
        }
      )
    },
    async addLog (data) {
      const chain = await this.addWorkLog()
      chain.params(data)
        .onSuccess((res, result) => {
          const { message } = result
          this.$message.success(message)
        })
        .onFail((err, result) => {
          console.log(err)
          const { payload } = result
          this.$notification['error']({
            message: this.$t('message["115"]'),
            description: payload[0].message
          })
        })
        .fetch()
    }
  }
}
</script>
<style lang="scss">
.work_index {
  .edit_container {
    .quill-editor {
      .ql-container {
        height: calc(448px) !important;
      }
    }
  }
  .spin-style {
    position: absolute;
    top: 50%;
    left: 50%;
  }
}
</style>
